import React from "react";

export default function QuestionnaireCompletionBySurvey({ questionnaires }) {

    /* =========================
       Helpers
       ========================= */

    function safePercent(value) {
        if (value === null || value === undefined) {
            return 0;
        }

        const num = Number(value);

        if (isNaN(num)) {
            return 0;
        }

        return Math.max(0, Math.min(100, Math.round(num)));
    }

    /* =========================
       Styles
       ========================= */

    const styles = {

        container: {
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            padding: "10px 6px"
        },

        row: {
            display: "flex",
            alignItems: "center",
            gap: "10px"
        },

        label: {
            width: "200px",
            fontSize: "12px",
            fontWeight: 500,
            color: "#333",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
        },

        barTrack: {
            flex: 1,
            height: "10px",
            backgroundColor: "#eee",
            borderRadius: "5px",
            overflow: "hidden"
        },

        barFill: {
            height: "100%",
            backgroundColor: "#4c9aff",
            borderRadius: "5px",
            transition: "width 0.4s ease"
        },

        percentLabel: {
            fontSize: "11px",
            fontWeight: 600,
            color: "#333",
            minWidth: "36px",
            textAlign: "right"
        }
    };

    /* =========================
       Guard
       ========================= */

    if (!Array.isArray(questionnaires) || questionnaires.length === 0) {
        return null;
    }

    /* =========================
       Render
       ========================= */

    return (
        <div style={styles.container}>

            {questionnaires.map(function (q) {

                const percent = safePercent(q.averagePercentComplete);

                return (
                    <div key={q.questionnaireId} style={styles.row}>

                        {/* Label */}
                        <div style={styles.label} title={q.title}>
                            {q.title}
                        </div>

                        {/* Bar */}
                        <div style={styles.barTrack}>
                            <div
                                style={{
                                    ...styles.barFill,
                                    width: percent + "%"
                                }}
                                title={percent + "% complete"}
                            />
                        </div>

                        {/* % label */}
                        <div style={styles.percentLabel}>
                            {percent}%
                        </div>

                    </div>
                );
            })}

        </div>
    );
}
